export default "__VITE_ASSET__DgltAGac__"